import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { switchMap } from 'rxjs';

import { AuthService } from '@core/services/auth.service';

/** Auth endpoints that must not carry a stale Bearer token (login, refresh, etc.). */
const ANONYMOUS_AUTH_SEGMENTS = [
	'/auth/login',
	'/auth/logout',
	'/auth/forgot-password',
	'/auth/reset-password',
	'/auth/refresh',
] as const;

function isAnonymousAuthRequest(url: string): boolean {
	return ANONYMOUS_AUTH_SEGMENTS.some((segment) => url.includes(segment));
}

/** Attaches the JWT access token to Manager API requests when present. */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
	if (isAnonymousAuthRequest(req.url)) {
		return next(req);
	}

	if (req.headers.has('Authorization')) {
		return next(req);
	}

	const auth = inject(AuthService);

	return auth.whenAccessTokenReady().pipe(
		switchMap(() => {
			const token = auth.accessToken();
			if (!token) {
				return next(req);
			}

			return next(
				req.clone({
					setHeaders: {
						Authorization: `Bearer ${token}`,
					},
				}),
			);
		}),
	);
};
